
import { Request, BaseApiUrl } from "./api";
// 生产线管理
// 列表
export const getSysStationLineListPage = (params) => {
    return Request.get(`${BaseApiUrl}/api/SysStationLine/get`, { params: params });
};
//编辑
export const editSysStationLine = (params) => {
    return Request.post(`${BaseApiUrl}/api/SysStationLine/put`, params);
};
//新增
export const addSysStationLine = (params) => {
    return Request.post(`${BaseApiUrl}/api/SysStationLine/post`, params);
};
//删除
export const deleteSysStationLine = (params) => {
    return Request.post(`${BaseApiUrl}/api/SysStationLine/delete`, params);
};
// export const deleteSysStationLine = (params) => {
//     return Request.delete(`${BaseApiUrl}/api/SysStationLine/delete`, {
//         data: params,
//         headers: {
//             "Content-Type": "application/json-patch+json",
//         },
//     });
// };

//搅拌站配置
// 列表
export const getSysStationListPage = (params) => {
    return Request.get(`${BaseApiUrl}/api/SysStation/get`, { params: params });
};
//编辑
export const editSysStation = (params) => {
    return Request.post(`${BaseApiUrl}/api/SysStation/put`, params);
};
//新增
export const addSysStation = (params) => {
    return Request.post(`${BaseApiUrl}/api/SysStation/post`, params);
};